import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import { NgxSpinnerService } from 'ngx-spinner';
import { WifiserviceService } from '../wifiservice.service';
import { error } from 'jquery';
import { ErrorService } from 'src/app/error.service';



@Component({
  selector: 'app-wifistudent-dialog',
  templateUrl: './wifistudent-dialog.component.html',
  styleUrls: ['./wifistudent-dialog.component.scss']
})
export class WifistudentDialogComponent implements OnInit {

  showPassword: boolean = false;
  showconfirmPassword: boolean = false;
  passwordForm: FormGroup;
  submitted: boolean = false;
  studentlist: any;
  userconfirmpassword: any;
  personaldetaile: any;
  // stateID: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<WifistudentDialogComponent>, private fb: FormBuilder, private spinner: NgxSpinnerService, private wifiService: WifiserviceService, private errorService: ErrorService,) { }
  ngOnInit(): void {
    console.log('wifi-student', this.data);

    // console.log('studentlist', this.studentlist);

    this.passwordForm = this.fb.group(
      {
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: ConfirmPasswordValidator("password", "confirmPassword")
      }
    )


  }


  wifiClose() {
    this.dialogRef.close();
  }

  passwordReset() {
    this.submitted = true;

    if (this.passwordForm.valid) {
      var payload = {
        "buildingId": this.data.buildingID,
        "stateId": this.data.stateID,
        "stateName": this.data.stateName,
        "cityId": this.data.cityID,
        "cityName": this.data.cityName,
        "campusId": this.data.campusID,
        "campusName": this.data.campusName,
        "studentList": [
          {
            "admNo": this.data.admNo,
            "name": this.data.studentName,
            "dob": this.data.dob,
            "password": this.passwordForm.value.confirmPassword
          }

        ],
        "merakiSsidDetails": [
          {
            "ssids": this.data.wifiID,
            "ssidName": this.data.wifiName
          }
        ]
      }
      console.log('payload', payload);
      this.spinner.show();
      this.wifiService.wifisave(payload).subscribe(
        {
          next: (res) => {
            this.personaldetaile = res;
            this.spinner.hide();
            console.log('save', this.personaldetaile.message);
            this.errorService.errorDisplay(200, 'Success', '');
          },
          error: (error) => {
            this.spinner.hide();
            console.log('error', error);
            this.errorService.errorDisplay(Number(error.status), 'Error', 'Save Details');
          }
        }
      )

      this.dialogRef.close();

    }
  }







}
